import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IPoliticalPartyPagedRequest } from '../../../../model/sge/political-party/request/political-party-paged-request';
import { IPoliticalPartyAddEditRequest } from '../../../../model/sge/political-party/request/political-party-add-edit-request';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';
import { IPoliticalPartyResponse } from '../../../../model/sge/political-party/response/political-party-response';

const defaultPath = 'PoliticalParty';

const list = async (params: IPoliticalPartyPagedRequest): Promise<Pagination<IPoliticalPartyPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => Object.assign(new Pagination<IPoliticalPartyPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<IPoliticalPartyResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IPoliticalPartyAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    });
};

const edit = async (id: number, params: IPoliticalPartyAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    });
};

const listAll = async (): Promise<IPoliticalPartyPagedResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/all`
    }).then((response) => response.data);
};

const PoliticalPartyAppService = { list, getById, add, edit, listAll };
export default PoliticalPartyAppService;
